import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { ReInstateWithdrawReason } from 'src/app/admin-config/re-instate-withdraw-reasons/re-instate-withdraw-reason/re-instate-withdraw-reason';
import { ReInstateWithdrawReasonsService } from 'src/app/admin-config/re-instate-withdraw-reasons/re-instate-withdraw-reasons.service';
import { ContactCenterService } from 'src/app/admin/contact-center/contact-center.service';
import { User } from 'src/app/admin/users/user/user';
import { Application } from 'src/app/applications/application/application';
import { CoreComponent } from 'src/app/core/core.component';
import { Attachment } from 'src/app/core/models';
import { UsersService } from 'src/app/users/users.service';
declare var $: any;
@Component({
  selector: 'app-re-instate-withdraw',
  templateUrl: './re-instate-withdraw.component.html',
  styleUrls: ['./re-instate-withdraw.component.scss']
})
export class ReInstateWithdrawComponent  extends CoreComponent<ReInstateWithdrawReason>  {

  @Input() status: string;
    user: User = new User();
    item: ReInstateWithdrawReason = new ReInstateWithdrawReason();
    public validated: boolean;
    @Input() public application: Application;
    @ViewChild('ngForm', {static: false}) public ngForm: NgForm;
  
    constructor(public modalService: NgbModal, public servicesService: ReInstateWithdrawReasonsService, public contactCenterService: ContactCenterService,private router: Router,
                public route: ActivatedRoute, private matSnackBar: MatSnackBar,
                protected gaService: GoogleAnalyticsService,public activeModal: NgbActiveModal,
                public userServices: UsersService) {
      super(servicesService, route);
    
    }
  
  onSubmit() {
    if (!this.ngForm.valid) {
          this.validated = true;
          $('html, body').animate({
            scrollTop: 0
          }, 1000, function() {
          });
          return;
        } else {
          this.blockUI.start();
            this.servicesService.saveReInstateWithdrawal(this.application).subscribe((item: Application) => {
              this.blockUI.stop();
              this.activeModal.close();
              this.application = item;
            }, (error: HttpErrorResponse) => {
              this.blockUI.stop();
              this.matSnackBar.open(error.error.message, 'Okay', {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            });
        }
  }

  showMatSnackBar(message: string) {
    this.matSnackBar.open(message, 'Okay', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }  

  sendGenericErrorMessage() {
    this.showMatSnackBar("Form is not valid, please verify all required fields are populated");
  }

  formValid(): boolean {
    if (!this.ngForm.valid) {
      this.sendGenericErrorMessage();
      return false;
    }
    return true;
  }

  allFormFieldsValid(): boolean {    
    return this.formValid();
  }

}
